import { FC, ReactNode } from 'react'
import './index.less'
import BackgroundBox from '../BackgroundBox'
import PerFlexRow from '../FlexRow'
import { TShirtSize } from '../../util/types'

interface Props {
  tabs: ReactNode
  actions?: ReactNode
  justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between'
  mb?: TShirtSize
  color?: 'white75' | 'white' | 'transparent' | 'boxshadow' | 'maintenance' | 'gray-1' | 'gray-2'
}

export const PerTabBarContent: FC<Props> = ({ tabs, actions, justify = 'end', mb = 'm', color = 'white75' }) => {
  return (
    <BackgroundBox noPadding mb={mb} r color={color} className="per-tabbarContent--height">
      <PerFlexRow justify={actions ? 'space-between' : justify} align="middle" noWrap>
        {actions && (
          <BackgroundBox noPadding color={color} noShadow className="per-flexRow--growShrink per-tabbarContent--selector" mr="m">
            <PerFlexRow align="middle" className="per-tabbarContent--height">
              {actions}
            </PerFlexRow>
          </BackgroundBox>
        )}
        {tabs}
      </PerFlexRow>
    </BackgroundBox>
  )
}
